import gql from "graphql-tag";

export const s3FilesAndImages = gql`
  query S3FilesAndImages($filePath: String) {
    s3FilesAndImages(filePath: $filePath) {
      filePath
      fileHttp
      subFile {
        fileName
        fileType
      }
    }
  }
`;
